import { useEffect, useState } from "react";
import { Eye } from "lucide-react";
import { Button } from "./ui/button";

export const AccessibilityToggle = () => {
  const [on, setOn] = useState(() => localStorage.getItem("a11y") === "1");

  useEffect(() => {
    document.documentElement.classList.toggle("a11y", on);
    localStorage.setItem("a11y", on ? "1" : "0");
  }, [on]);

  return (
    <Button
      variant="ghost"
      size="icon"
      data-testid="a11y-toggle"
      aria-pressed={on}
      aria-label="Toggle high contrast and large text"
      title="High contrast / large text"
      onClick={() => setOn((v) => !v)}
      className={`rounded-full shrink-0 ${on ? "bg-stone-900 text-white hover:bg-black" : "text-stone-700 hover:bg-[#E8EFE9]"}`}
    >
      <Eye className="w-5 h-5" />
    </Button>
  );
};
